import { FilterBar } from "@/components/FilterBar";
import { Header } from "@/components/header";
import { SearchIcon } from "@/components/icons/search";
import {
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Stack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useCallback, useEffect, useState } from "react";
import { EventIndexDto, EventIndexFilterDto } from "./types";
import { MobileContent } from "./mobileContent";
import { Footer } from "@/components/footer";
import { DesktopContent } from "./desktopContent";
import { useEvent } from "@/hooks/useEvent";
import { useCustomToast } from "@/hooks/useToast";
import LoadingOverlay from "@/components/overlay";
const initialFilter: EventIndexFilterDto = {
  name: "",
  date: "",
};

export const Events = () => {
  const [filter, setFilter] = useState<EventIndexFilterDto>(initialFilter);
  const [page, setPage] = useState<number>(1);
  const [lastPage, setLastPage] = useState<number>(1);
  const [events, setEvents] = useState<EventIndexDto[]>([]);
  const [totalEvents, setTotalEvents] = useState<number>(0);
  const { getEvents } = useEvent();
  const { customToast } = useCustomToast();
  const isTablet = useBreakpointValue({ base: true, md: true, lg: false });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [filterValue, setFilterValue] = useState("");

  const callbackEvents = useCallback(() => {
    setIsLoading(true);
    getEvents({ page, ...filter })
      .then((response) => {
        setEvents(response.data.data);
        setTotalEvents(response.data.total);
        setLastPage(response.data.lastPage);
      })
      .catch((error) =>
        customToast("error", [error.response.data.message].join(", "))
      )
      .finally(() => setIsLoading(false));
  }, [page, filter, getEvents, customToast]);

  useEffect(() => {
    callbackEvents();
  }, [page, filter]);

  const filters = [
    {
      field: (
        <HStack alignItems="center" key={1} width={"100%"}>
          <Text w="30%">Buscar por</Text>
          <Select
            w="100%"
            h={9}
            borderRadius={4}
            textIndent="10px"
            border="1px solid #EAEAEA"
            bgColor="neutral.0"
            onChange={(value) => {
              const selected = value.target.value;
              setFilterValue(selected);
            }}
          >
            <option value="">Selecione</option>
            <option value="name">Nome da Turma</option>
            <option value="typeName">Tipo</option>
            <option value="local">Local</option>
          </Select>
        </HStack>
      ),
    },
    {
      field: (
        <InputGroup alignItems="center" key={2} w={"100%"}>
          <InputLeftElement pointerEvents="none" top="" left={1}>
            <SearchIcon />
          </InputLeftElement>
          <Input
            type="text"
            placeholder="Digite sua busca."
            _placeholder={{ color: "neutral.50" }}
            w="100%"
            h={9}
            borderRadius={4}
            textIndent="10px"
            border="1px solid #EAEAEA"
            bgColor="neutral.0"
            onChange={(value) => {
              const selected = value.target.value;
              setFilter({ ...filter, [filterValue]: selected });
            }}
          />
        </InputGroup>
      ),
    },
  ];

  return (
    <Stack
      h={totalEvents < 2 ? "100vh" : "100%"}
      w="100%"
      position="relative"
      gap={0}
    >
      <Header />
      <FilterBar title="Meus Eventos" filters={filters} columns={2} />
      {isLoading && <LoadingOverlay />}
      {isTablet ? (
        <MobileContent
          events={events}
          page={page}
          lastPage={lastPage}
          setPage={setPage}
        />
      ) : (
        Array.isArray(events) &&
        events.length > 0 && (
          <DesktopContent
            events={events}
            page={page}
            lastPage={lastPage}
            setPage={setPage}
          />
        )
      )}
      {!isTablet && <Footer />}
    </Stack>
  );
};
